module.exports = __webpack_public_path__ + "img/bz.758c453a.jpg";